import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface FiscalDeviceSetDefaultParams {
    readonly id: number;
}

export type FiscalDeviceSetDefaultResponse = {
    value: number,
    version: string
}[];

export class FiscalDeviceSetDefaultCommand extends Command<FiscalDeviceSetDefaultParams, FiscalDeviceSetDefaultResponse> { }

export class FiscalDeviceSetDefaultCommandHandlerBase implements CommandHandler<FiscalDeviceSetDefaultCommand, FiscalDeviceSetDefaultParams, FiscalDeviceSetDefaultResponse> {
    private static Url = TaggedUrl.join('system/devices/default/:id', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: FiscalDeviceSetDefaultCommand): Promise<FiscalDeviceSetDefaultResponse> {
        const { data } = await this.http.put(fillPlaceholders(FiscalDeviceSetDefaultCommandHandlerBase.Url, { id: command.params?.id }));

        return data;
    }
}
